import { service } from '@ember/service';
import type StoreService from '@ember-data/store';
import Component from '@glimmer/component';
import { format, subMinutes } from 'date-fns';
import { task } from 'ember-concurrency';
import type StateService from 'garaje/services/state';

interface UnavailableResourcePopupArgs {
  selectedDate: Date;
  featureName: string;
  mapFloorName: string;
  resourceType: string;
  isReservedByCurrentUser: boolean;
  isAssignedToCurrentUser: boolean;
  hasAssignment: boolean;
  onReleaseResourceTask: () => Promise<void>;
  onBookResource: () => Promise<void>;
  onCancel: () => void;
}

export default class UnavailableResourcePopup extends Component<UnavailableResourcePopupArgs> {
  @service declare state: StateService;
  @service declare store: StoreService;

  get formattedDate(): string {
    const displayDate = subMinutes(this.args.selectedDate, this.state.minutesBetweenTimezones(this.args.selectedDate));
    return format(displayDate, 'MMMM dd, yyyy');
  }

  get unavailabilityReason(): string {
    // A resource popup is unavailable if
    // 1. it is assigned to the current user
    //    - the current user can then reserve the resource
    // 2. it is reserved for the current user
    // 3. it is assigned to someone else
    // 4. it is reserved for someone else
    // 5. if it is assigned and reserved for someone else, then just show the assignment state
    if (this.args.isReservedByCurrentUser) {
      return 'Reserved for you';
    }

    if (this.args.isAssignedToCurrentUser) {
      return 'Assigned to you';
    }

    if (this.args.hasAssignment) {
      return 'Assigned to someone else';
    }

    return 'Reserved for someone else';
  }

  onBookResourceTask = task({ drop: true }, async () => {
    await this.args.onBookResource();
  });
}
